const LABELS = {
  bep: "BEP (bpd)",
  bhpStages: "BHP/Stage",
  bg: "Bg",
  bo: "Bo",
  chargePump1: "Charge pump 1",
  dischargePress: "Discharge pressure",
  eff: "Efficiency (%)",
  efficiency: "Efficiency",
  exportEfficiencyCurves: "Export efficiency curves",
  exportHeadCurves: "Export head curves",
  exportPowerCurves: "Export power curves",
  exportToExcel: "Export to excel",
  finalTDH: "Final TDH",
  flowCorrection: "Flow correction",
  gasHandler: "Gas handler",
  goToStage: "Go to stage",
  gor: "GOR",
  glr: "GLR",
  gvf: "GVF %",
  gvfIntake: "GVF intake",
  highPressureHousing: "High pressure housing",
  highStrengthShaft: "High strength shaft",
  housingPressure: "Housing pressure",
  housingPressureLimit: "Housing pressure limit",
  hp: "hp",
  headCorrection: "Head correction",
  hz: "Frequency (Hz)",
  intakeFlow: "Intake flow",
  liftContribution: "Lift contribution",
  liftStage: "Lift stage",
  liftPerStage: "Lift/Stage",
  liftPerStageft: "Lift per stage (ft)",
  max: "Max (bpd)",
  min: "Min (bpd)",
  minStages: "Minimum no. of stages",
  motorFullLoadSpeed60Hz: "Motor full load speed @ 60 Hz",
  desiredNoStages: "Desired no. of stages",
  noOfStages: "No. stages",
  operatingFreq: "Operating freq",
  percentHousingLoad: "Percent housing load",
  percentShaftLoad: "Percent shaft load",
  pmax: "Pmax",
  power: "Power",
  powerAt55Hz: "Power @ 55 Hz",
  powerAt60Hz: "Power @ 60 Hz",
  powerAtFrequency: "Power at specified frequency (Hz)",
  powerContribution: "Power contribution",
  powerCorrection: "Power correction",
  powerPerStage: "Power per stage (hp)",
  project: "Project",
  pumpName: "Pump name",
  pumps: "Pumps",
  pumpSelected: "Pump selected",
  intakeSettingMD: "Intake setting @ measured depth",
  powerTotal: "Total power (hp)",
  rs: "Rs",
  shaftRating: "Shaft rating HS",
  showAllPumps: "Show all pumps",
  spGr: "SpGr",
  stageNo: "Stage no",
  standardHousing: "Standard housing",
  standardShaft: "Standard shaft",
  targetFlowRate: "Target flow rate",
  tfv: "TFV",
  totalDynamicHeadOverride: "Total dynamic head override",
  totalPower: "Total power",
  typeOfHousing: "Type of housing",
  typeOfShaft: "Type of shaft",
  volumegas: "Volume of gas",
};

export default LABELS;
